module.exports = __webpack_public_path__ + "static/media/unsplash.1016b6c7.svg";